import { Suspense } from 'react'

/**
 * Suspense boundary for lazily-loaded routes.
 *
 * Its own file so `router.tsx` exports only the router — a module that exports
 * both a component and a value breaks React Fast Refresh.
 */
export function LazyRoute({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<div className="min-h-screen" />}>{children}</Suspense>
}
